<template>
  <div class="star-rating">
    <div class="star-rating__stars">
      <div v-for="num in [1, 2, 3, 4, 5]" :key="num" class="star-rating__group">
        <input
          :id="`star-rating-${num}`"
          v-model="model"
          type="radio"
          name="star-rating"
          :value="num"
          class="star-rating__input"
          :data-testid="`star-rating-${num}`"
        />
        <label
          :tabindex="0"
          :aria-label="`rating-${num}`"
          :title="`rating-${num}`"
          :for="`star-rating-${num}`"
          class="star-rating__label"
          @keydown.enter="model = num"
        >
          <img
            class="star-rating__image"
            :class="`star-rating__image--${getImageName(num)}`"
            :src="`/images/star-rating/${getImageName(num)}.svg`"
          />
        </label>
      </div>
    </div>
    <div v-if="displayLabels" class="star-rating__labels">
      <div class="star-rating__label">{{ props.labelLeft }}</div>
      <div class="star-rating__label">{{ props.labelRight }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  labelLeft?: string
  labelRight?: string
}

const model = defineModel<number | null>()
const props = defineProps<Props>()

const displayLabels = computed(() => {
  return props.labelLeft && props.labelRight
})

const getImageName = (n: number) => {
  if (model.value === null || model.value === undefined) return 'star-empty'
  return n <= model.value ? 'star-filled' : 'star-empty'
}
</script>

<style lang="scss" scoped>
.star-rating {
  max-width: 336px;

  &__stars {
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    margin-bottom: 18px;
  }

  &__label {
    margin: 0;
    cursor: pointer;
  }

  &__input {
    display: none;
  }

  &__image {
    width: 38px;
    height: 36px;
  }

  &__label {
    font-size: var(--font-size-paragraph-s);
  }

  &__labels {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
}
</style>
